// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markerbtn{
    margin:5px;
    background-color:gray;
}

.markerbtn.confirm {
    background-color: green;
}
    .markerbtn.delete {
        background-color: red;
    }

.markerDIV {
    position: absolute;
    box-sizing: border-box;
    border: 1px solid red;
}

    .markerDIV.selectedMarker {
        border-color: green;
        z-index: 1;
    }

.buttonDIV {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/marker/marker.control.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;IACI;QACI,qBAAqB;IACzB;;AAEJ;IACI,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;AACzB;;IAEI;QACI,mBAAmB;QACnB,UAAU;IACd;;AAEJ;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;AACd","sourcesContent":[".markerbtn{\n    margin:5px;\n    background-color:gray;\n}\n\n.markerbtn.confirm {\n    background-color: green;\n}\n    .markerbtn.delete {\n        background-color: red;\n    }\n\n.markerDIV {\n    position: absolute;\n    box-sizing: border-box;\n    border: 1px solid red;\n}\n\n    .markerDIV.selectedMarker {\n        border-color: green;\n        z-index: 1;\n    }\n\n.buttonDIV {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
